module.exports = __webpack_public_path__ + "static/media/gt-america-standard-medium-italic.ef01359a.woff";